import { MesssageReducer as Message } from './ComponentReducer/message';
import { SummaryMesssageReducer as SummaryMessage } from './ComponentReducer/summary_message';


export const reducers = {

  Message,
  SummaryMessage, 
};
